const Init = () => {

    // console.log("階層「group」で利用する機能はこちらに記述してください。");
    // $(function () {
  
    if( document.getElementById('group') != null ){
      
      
      // ---------- groupトップページ チャート部分
      const group_top = document.getElementById('group').classList.contains('group_top');
      
        if( group_top ){

            const targetArea = document.getElementById('target_chart');
            const categories = [];

            const category_name = targetArea.querySelectorAll('[data-category]');

            for ( let i=0 ; i < category_name.length; i++ ){

                categories.push(category_name[i].textContent);

            }

            const companies = targetArea.querySelectorAll('[data-name]');

            for (let j=0; j < companies.length; j++){
              
                const newSpan = document.createElement('span');
                newSpan.className = 'p-category';
                
                let idx = companies[j].dataset.name;
                newSpan.textContent = categories[idx];

                companies[j].firstElementChild.insertBefore(newSpan, companies[j].querySelector('.p-company'));

            }
          
        }
        // ---------- // groupトップページ チャート部分

    }

}

export default Init;
